function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n                position: sticky;\n                left: 0;\n                right: 0;\n                top: ",
        ";\n                bottom: ",
        ";\n\n                &.stuck {\n                    margin-top: 0px;\n                }\n            "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n\n    & + * {\n        ",
        "\n\n        ",
        "\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { fadeOverhang } from "./fade";
export var Sticky = function(props) {
    var children = props.children, shadow = props.shadow, sticky = props.sticky;
    var siblingRef = useRef(null);
    useEffect(function() {
        if (sticky) {
            var ref;
            var el = (ref = siblingRef.current) === null || ref === void 0 ? void 0 : ref.nextElementSibling;
            if (el && _instanceof(el, HTMLElement)) {
                el.style.position = "sticky";
                el.style.left = "0px";
                el.style.right = "0px";
                if (sticky === "top") {
                    el.style.top = "-0.1px";
                } else {
                    el.style.bottom = "-0.1px";
                }
                var observer = new IntersectionObserver(function(param) {
                    var _param = _slicedToArray(param, 1), e = _param[0];
                    return e.target.classList.toggle("stuck", e.intersectionRatio < 1);
                }, {
                    threshold: [
                        1
                    ]
                });
                observer.observe(el);
                return function() {
                    observer.disconnect();
                };
            }
        }
    }, [
        !!shadow,
        sticky
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StyleSibling, {
                ref: siblingRef,
                shadow: shadow,
                sticky: sticky
            }),
            children
        ]
    });
};
var StyleSibling = styled.span.withConfig({
    componentId: "sc-a270f67b-0"
})(_templateObject1(), function(param) {
    var sticky = param.sticky;
    return sticky && css(_templateObject(), sticky === "top" ? 0 : "auto", sticky === "bottom" ? 0 : "auto");
}, function(param) {
    var shadow = param.shadow;
    return shadow && fadeOverhang(_objectSpread({}, shadow, {
        showOnStuck: true
    }));
});
